export const FALLBACK_HERO_DATA = {
  type: 'contentPage',
  title: 'Static Fallback Hero ',
  modules: [
    {
      ctas: [
        {
          copy: 'Try ClassPass',
          type: 'callToAction',
          color: 'primary_solid',
          contentfulId: 'StaticFallbackHero:39205',
          url: '\u002Fpricing',
        },
        {
          url: '\u002Fsearch',
          copy: 'Find studios nearby',
          type: 'callToAction',
          color: 'primary_opaque',
          contentfulId: 'StaticFallbackHero:948483',
        },
      ],
      type: 'hero',
      title: ['Every class with one fitness pass'],
      subtitle: [
        'Committing is hard — so don’t. Work out at any gym, try any workout and do it all with one app. Try ClassPass today.',
      ],
      alignment: 'left',
      hero_name: 'Static Fallback Hero',
      leadCapture: false,
      mobileImage:
        '\u002F\u002Fimages.ctfassets.net\u002Few96z4wsnz93\u002F1RPiy1WGaoxO4fnbcsSdhR\u002F907c293a762827ade0c68ca80d1ad6f8\u002FSplash-MobileHero-v4.jpg',
      contentfulId: 'StaticFallbackHero:9248',
      desktopImage:
        '\u002F\u002Fimages.ctfassets.net\u002Few96z4wsnz93\u002F4ilOX3g9tUOiw7DdCqGdxO\u002F3550d55ba10759fceb147e7d8e0a5210\u002Fhomepagehero-anthemv6.jpg',
      heroTextColor: 'dark',
      textJustification: 'far-left',
      verticalAlignment: 'middle-split',
    },
  ],
  metadata: {
    title: 'ClassPass | Fitness Studios & Classes',
    ogImage:
      '\u002F\u002Fimages.ctfassets.net\u002Few96z4wsnz93\u002F3lVFApyuM8YCOuyAWEgSWQ\u002Fd86b94d30106a8c7a48d50f4d56ac0c9\u002F20170630_FB-Metadata_1200x630_Homepage.jpg',
    ogTitle: 'ClassPass | The Best Fitness Studios, Classes and Experiences',
    audience: ['unsubscribed'],
    description:
      'Yoga. Cycling. Boxing. One app gets you into the best fitness classes near you. Just search a class, reserve your spot and work out.',
    shouldIndex: true,
    contentfulId: 'StaticFallbackHero:397947',
    ogDescription:
      'The best fitness studios, classes, and experiences are on ClassPass. Work out where you want, when you want, and how you want, all with one membership.',
  },
  contentfulId: 'StaticFallbackHero:1234',
  props: {
    msaAlias: 'new-york',
    msaId: 1,
    msaCurrencyFormat: '$',
    path: '\u002Ftry\u002Ffallback',
  },
};
